"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATMainScene = void 0;
const ATAudioScene_1 = require("./ATAudioScene");
const ATSceneNames_1 = require("./ATSceneNames");
const ATTextButton_1 = require("./ATTextButton");
const Game_1 = require("./Game");
const KHContainer_1 = require("./KH/KHContainer");
class ATMainScene extends Phaser.Scene {
    constructor() {
        super(ATSceneNames_1.default.Menu);
    }
    init() {
    }
    create() {
        this.bg = new KHContainer_1.KHContainer(this, 0, 0, Game_1.game.width, Game_1.game.height, 0xFFFFFF, 1);
        // this.bg.setInteractive(new Phaser.Geom.Rectangle(game.width/2, game.height/2, game.width, game.height), Phaser.Geom.Rectangle.Contains);
        this.bg.on('pointerdown', () => {
            goToNextScene(500);
        });
        const goToNextScene = (timeout) => {
            ATAudioScene_1.ATAudioScene.Shared.playSfx('click');
            this.scene.start(ATSceneNames_1.default.Game, { timeout });
        };
        const buttonWidth = 200;
        const buttonHeight = 75;
        const button = new ATTextButton_1.default(this, Game_1.game.width / 4 - buttonWidth / 2, Game_1.game.height / 2, buttonWidth, buttonHeight, 'Easy');
        button.setInteractable(true);
        button.on('pointerdown', () => {
            goToNextScene(4000);
        });
        const button2 = new ATTextButton_1.default(this, Game_1.game.width * 2 / 4 - buttonWidth / 2, Game_1.game.height / 2, buttonWidth, buttonHeight, 'Normal');
        button2.setInteractable(true);
        button2.on('pointerdown', () => {
            goToNextScene(1000);
        });
        const button3 = new ATTextButton_1.default(this, Game_1.game.width * 3 / 4 - buttonWidth / 2, Game_1.game.height / 2, buttonWidth, buttonHeight, 'Hard');
        button3.setInteractable(true);
        button3.on('pointerdown', () => {
            goToNextScene(500);
        });
        this.mute = this.add.sprite(Game_1.game.width * 0.9, Game_1.game.height * 0.9, 'volume_on').setOrigin(0.5, 0.5);
        this.mute.setDisplaySize(Game_1.game.width * 0.05, Game_1.game.width * 0.05);
        this.mute.setTint(0x0);
        this.mute.setInteractive();
        this.mute.on('pointerdown', () => {
            this.setMute(!Game_1.game.mute.get());
            ATAudioScene_1.ATAudioScene.Shared.playSfx('click');
        });
        this.setMute(Game_1.game.mute.get());
        this.add.existing(this.bg);
        this.title = this.add.dom(Game_1.game.width / 2, Game_1.game.height * 0.25, 'div', Game_1.game.fontStyle(0.18 * Game_1.game.height), "Attention.").setOrigin(0.5, 0.5);
    }
    setMute(mute) {
        Game_1.game.mute.set(mute);
        Game_1.game.sound.mute = Game_1.game.mute.get();
        this.mute.setTexture(mute ? 'volume_off' : 'volume_on');
    }
}
exports.ATMainScene = ATMainScene;
